"use client";

import { faArrowLeft } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@yardzen/ui/components/button";
import { usePathname, useRouter } from "next/navigation";
import { useFormStatus } from "react-dom";

export function BackButton({
  backUrl,
  isFirstQuestion,
}: {
  backUrl: string;
  isFirstQuestion: boolean;
}) {
  const pathname = usePathname();
  const baseQuizPath = pathname
    ? `/${pathname.split("/").filter(Boolean)[0]}`
    : "";
  const url =
    isFirstQuestion && baseQuizPath.length > 0 ? baseQuizPath : backUrl;
  const router = useRouter();
  const { pending } = useFormStatus();

  if (typeof window !== "undefined") {
    // Preload route for previous question
    router.prefetch(backUrl);
  }

  return (
    <Button
      variant="secondary"
      className="w-1/2 flex-1"
      startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
      type="button"
      onClick={() => router.push(url)}
      disabled={pending}
    >
      Back
    </Button>
  );
}
